import React from 'react';
import BasicMeta from '../BasicMeta';

const descriptions = {
  dk: {
    description: 'EURO2020',
    title: 'EURO2020',
  },
};

export default () => <BasicMeta descriptions={descriptions} />;



// WEBPACK FOOTER //
// ./src/component/EURO2020/EURO2020Meta.jsx